import Ajax from '../js/common/ajax';

/**
 * 存货管理模块API
 */
export default {
  /**
   * 存货类别相关接口
   */
  category: {
    // 查询列表
    list(params) {
      return Ajax.get('/inventory/category', params);
    },
    // 根据账套ID查询
    listByAccountSetsId(accountSetsId) {
      return Ajax.get(`/inventory/category/list/${accountSetsId}`);
    },
    // 根据父ID查询子类别
    listByParentId(parentId) {
      return Ajax.get(`/inventory/category/children/${parentId}`);
    },
    // 新增
    create(data) {
      return Ajax.post('/inventory/category', data);
    },
    // 修改
    update(data) {
      return Ajax.put('/inventory/category', data);
    },
    // 删除
    delete(id) {
      return Ajax.delete(`/inventory/category/${id}`);
    }
  },

  /**
   * 存货档案相关接口
   */
  item: {
    // 查询列表
    list(params) {
      return Ajax.get('/inventory/item', params);
    },
    // 根据账套ID查询
    listByAccountSetsId(accountSetsId) {
      return Ajax.get(`/inventory/item/list/${accountSetsId}`);
    },
    // 根据类别ID查询
    listByCategoryId(categoryId) {
      return Ajax.get(`/inventory/item/byCategory/${categoryId}`);
    },
    // 根据状态查询
    listByStatus(accountSetsId, status) {
      return Ajax.get('/inventory/item/byStatus', { accountSetsId, status });
    },
    // 新增
    create(data) {
      return Ajax.post('/inventory/item', data);
    },
    // 修改
    update(data) {
      return Ajax.put('/inventory/item', data);
    },
    // 删除
    delete(id) {
      return Ajax.delete(`/inventory/item/${id}`);
    }
  },

  /**
   * 存货出入库记录相关接口
   */
  record: {
    // 查询列表
    list(params) {
      return Ajax.get('/inventory/record', params);
    },
    // 根据账套ID查询
    listByAccountSetsId(accountSetsId) {
      return Ajax.get(`/inventory/record/list/${accountSetsId}`);
    },
    // 根据存货ID查询
    listByItemId(itemId) {
      return Ajax.get(`/inventory/record/byItem/${itemId}`);
    },
    // 根据日期范围查询
    listByDateRange(accountSetsId, startDate, endDate) {
      return Ajax.get('/inventory/record/byDateRange', { accountSetsId, startDate, endDate });
    },
    // 根据单据类型查询
    listByBillType(accountSetsId, billType) {
      return Ajax.get('/inventory/record/byBillType', { accountSetsId, billType });
    },
    // 入库操作
    stockIn(data) {
      return Ajax.post('/inventory/record/stockIn', data);
    },
    // 出库操作
    stockOut(data) {
      return Ajax.post('/inventory/record/stockOut', data);
    },
    // 新增
    create(data) {
      return Ajax.post('/inventory/record', data);
    },
    // 修改
    update(data) {
      return Ajax.put('/inventory/record', data);
    },
    // 删除
    delete(id) {
      return Ajax.delete(`/inventory/record/${id}`);
    }
  }
};
